import { Link } from 'gatsby';

export default function NavItem(props) {
    return (
        <Link
            to={props.to}
            className='block py-2 text-center text-lg no-underline lg:px-1 2xl:px-3'
            activeClassName='border-b border-avenue-blue-500'
        >
            {props.title}
        </Link>
    );
}
